export const albums_data = {
   "our-family": {
      "name": "Our Family",
      "photos": [
         {
            "faces": [],
            "height": 853,
            "name": "checking-their-planner-4008732.jpg",
            "slug": "checking-their-planner-4008732-jpg",
            "src": "/fussel-demo/static/_gallery/albums/our-family/1280x853_checking-their-planner-4008732-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1024x682_checking-their-planner-4008732-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1280x853_checking-their-planner-4008732-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/500x333_checking-their-planner-4008732-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/800x533_checking-their-planner-4008732-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/our-family/500x333_checking-their-planner-4008732-jpg.jpg",
            "width": 1280
         },
         {
            "faces": [],
            "height": 1920,
            "name": "couple-checking-their-planner-4008738.jpg",
            "slug": "couple-checking-their-planner-4008738-jpg",
            "src": "/fussel-demo/static/_gallery/albums/our-family/1280x1920_couple-checking-their-planner-4008738-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1024x1536_couple-checking-their-planner-4008738-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1280x1920_couple-checking-their-planner-4008738-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/500x750_couple-checking-their-planner-4008738-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/800x1200_couple-checking-their-planner-4008738-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/our-family/500x750_couple-checking-their-planner-4008738-jpg.jpg",
            "width": 1280
         },
         {
            "faces": [],
            "height": 853,
            "name": "couple-hugging-4008834.jpg",
            "slug": "couple-hugging-4008834-jpg",
            "src": "/fussel-demo/static/_gallery/albums/our-family/1280x853_couple-hugging-4008834-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1024x682_couple-hugging-4008834-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1280x853_couple-hugging-4008834-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/500x333_couple-hugging-4008834-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/800x533_couple-hugging-4008834-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/our-family/500x333_couple-hugging-4008834-jpg.jpg",
            "width": 1280
         },
         {
            "faces": [],
            "height": 1920,
            "name": "cute-little-boys-4008827.jpg",
            "slug": "cute-little-boys-4008827-jpg",
            "src": "/fussel-demo/static/_gallery/albums/our-family/1280x1920_cute-little-boys-4008827-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1024x1536_cute-little-boys-4008827-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1280x1920_cute-little-boys-4008827-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/500x750_cute-little-boys-4008827-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/800x1200_cute-little-boys-4008827-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/our-family/500x750_cute-little-boys-4008827-jpg.jpg",
            "width": 1280
         },
         {
            "faces": [],
            "height": 853,
            "name": "family-bonding-during-quarantine-4008772.jpg",
            "slug": "family-bonding-during-quarantine-4008772-jpg",
            "src": "/fussel-demo/static/_gallery/albums/our-family/1280x853_family-bonding-during-quarantine-4008772-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1024x682_family-bonding-during-quarantine-4008772-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1280x853_family-bonding-during-quarantine-4008772-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/500x333_family-bonding-during-quarantine-4008772-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/800x533_family-bonding-during-quarantine-4008772-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/our-family/500x333_family-bonding-during-quarantine-4008772-jpg.jpg",
            "width": 1280
         },
         {
            "faces": [],
            "height": 853,
            "name": "family-bonding-during-quarantine-4008773.jpg",
            "slug": "family-bonding-during-quarantine-4008773-jpg",
            "src": "/fussel-demo/static/_gallery/albums/our-family/1280x853_family-bonding-during-quarantine-4008773-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1024x682_family-bonding-during-quarantine-4008773-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1280x853_family-bonding-during-quarantine-4008773-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/500x333_family-bonding-during-quarantine-4008773-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/800x533_family-bonding-during-quarantine-4008773-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/our-family/500x333_family-bonding-during-quarantine-4008773-jpg.jpg",
            "width": 1280
         },
         {
            "faces": [],
            "height": 1920,
            "name": "family-bonding-during-quarantine-4008776.jpg",
            "slug": "family-bonding-during-quarantine-4008776-jpg",
            "src": "/fussel-demo/static/_gallery/albums/our-family/1280x1920_family-bonding-during-quarantine-4008776-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1024x1536_family-bonding-during-quarantine-4008776-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1280x1920_family-bonding-during-quarantine-4008776-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/500x750_family-bonding-during-quarantine-4008776-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/800x1200_family-bonding-during-quarantine-4008776-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/our-family/500x750_family-bonding-during-quarantine-4008776-jpg.jpg",
            "width": 1280
         },
         {
            "faces": [],
            "height": 853,
            "name": "family-bonding-during-quarantine-4008783.jpg",
            "slug": "family-bonding-during-quarantine-4008783-jpg",
            "src": "/fussel-demo/static/_gallery/albums/our-family/1280x853_family-bonding-during-quarantine-4008783-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1024x682_family-bonding-during-quarantine-4008783-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1280x853_family-bonding-during-quarantine-4008783-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/500x333_family-bonding-during-quarantine-4008783-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/800x533_family-bonding-during-quarantine-4008783-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/our-family/500x333_family-bonding-during-quarantine-4008783-jpg.jpg",
            "width": 1280
         },
         {
            "faces": [],
            "height": 853,
            "name": "family-bonding-during-quarantine-4008790.jpg",
            "slug": "family-bonding-during-quarantine-4008790-jpg",
            "src": "/fussel-demo/static/_gallery/albums/our-family/1280x853_family-bonding-during-quarantine-4008790-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1024x682_family-bonding-during-quarantine-4008790-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1280x853_family-bonding-during-quarantine-4008790-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/500x333_family-bonding-during-quarantine-4008790-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/800x533_family-bonding-during-quarantine-4008790-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/our-family/500x333_family-bonding-during-quarantine-4008790-jpg.jpg",
            "width": 1280
         },
         {
            "faces": [],
            "height": 1920,
            "name": "family-bonding-during-quarantine-4008802.jpg",
            "slug": "family-bonding-during-quarantine-4008802-jpg",
            "src": "/fussel-demo/static/_gallery/albums/our-family/1280x1920_family-bonding-during-quarantine-4008802-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1024x1536_family-bonding-during-quarantine-4008802-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1280x1920_family-bonding-during-quarantine-4008802-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/500x750_family-bonding-during-quarantine-4008802-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/800x1200_family-bonding-during-quarantine-4008802-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/our-family/500x750_family-bonding-during-quarantine-4008802-jpg.jpg",
            "width": 1280
         },
         {
            "faces": [],
            "height": 1920,
            "name": "family-bonding-during-quarantine-4008881.jpg",
            "slug": "family-bonding-during-quarantine-4008881-jpg",
            "src": "/fussel-demo/static/_gallery/albums/our-family/1280x1920_family-bonding-during-quarantine-4008881-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1024x1536_family-bonding-during-quarantine-4008881-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1280x1920_family-bonding-during-quarantine-4008881-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/500x750_family-bonding-during-quarantine-4008881-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/800x1200_family-bonding-during-quarantine-4008881-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/our-family/500x750_family-bonding-during-quarantine-4008881-jpg.jpg",
            "width": 1280
         },
         {
            "faces": [],
            "height": 5559,
            "name": "happy-young-mother-carrying-cute-infant-baby-in-arms-in-room-3845211.jpg",
            "slug": "happy-young-mother-carrying-cute-infant-baby-in-arms-in-room-3845211-jpg",
            "src": "/fussel-demo/static/_gallery/albums/our-family/1600x2400_happy-young-mother-carrying-cute-infant-baby-in-arms-in-room-3845211-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1024x1536_happy-young-mother-carrying-cute-infant-baby-in-arms-in-room-3845211-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1600x2400_happy-young-mother-carrying-cute-infant-baby-in-arms-in-room-3845211-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/500x750_happy-young-mother-carrying-cute-infant-baby-in-arms-in-room-3845211-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/800x1200_happy-young-mother-carrying-cute-infant-baby-in-arms-in-room-3845211-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/our-family/500x750_happy-young-mother-carrying-cute-infant-baby-in-arms-in-room-3845211-jpg.jpg",
            "width": 3706
         },
         {
            "faces": [],
            "height": 853,
            "name": "kids-playing-with-tissue-roll-4008795.jpg",
            "slug": "kids-playing-with-tissue-roll-4008795-jpg",
            "src": "/fussel-demo/static/_gallery/albums/our-family/1280x853_kids-playing-with-tissue-roll-4008795-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1024x682_kids-playing-with-tissue-roll-4008795-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1280x853_kids-playing-with-tissue-roll-4008795-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/500x333_kids-playing-with-tissue-roll-4008795-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/800x533_kids-playing-with-tissue-roll-4008795-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/our-family/500x333_kids-playing-with-tissue-roll-4008795-jpg.jpg",
            "width": 1280
         },
         {
            "faces": [],
            "height": 1920,
            "name": "mommy-kissing-little-boy-4008819.jpg",
            "slug": "mommy-kissing-little-boy-4008819-jpg",
            "src": "/fussel-demo/static/_gallery/albums/our-family/1280x1920_mommy-kissing-little-boy-4008819-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1024x1536_mommy-kissing-little-boy-4008819-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1280x1920_mommy-kissing-little-boy-4008819-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/500x750_mommy-kissing-little-boy-4008819-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/800x1200_mommy-kissing-little-boy-4008819-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/our-family/500x750_mommy-kissing-little-boy-4008819-jpg.jpg",
            "width": 1280
         },
         {
            "faces": [],
            "height": 1706,
            "name": "people-gathered-inside-house-sitting-on-sofa-1054974.jpg",
            "slug": "people-gathered-inside-house-sitting-on-sofa-1054974-jpg",
            "src": "/fussel-demo/static/_gallery/albums/our-family/1280x1706_people-gathered-inside-house-sitting-on-sofa-1054974-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1024x1364_people-gathered-inside-house-sitting-on-sofa-1054974-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1280x1706_people-gathered-inside-house-sitting-on-sofa-1054974-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/500x666_people-gathered-inside-house-sitting-on-sofa-1054974-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/800x1066_people-gathered-inside-house-sitting-on-sofa-1054974-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/our-family/500x666_people-gathered-inside-house-sitting-on-sofa-1054974-jpg.jpg",
            "width": 1280
         },
         {
            "faces": [],
            "height": 1920,
            "name": "woman-cooking-while-holding-her-laptop-4008741.jpg",
            "slug": "woman-cooking-while-holding-her-laptop-4008741-jpg",
            "src": "/fussel-demo/static/_gallery/albums/our-family/1280x1920_woman-cooking-while-holding-her-laptop-4008741-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1024x1536_woman-cooking-while-holding-her-laptop-4008741-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1280x1920_woman-cooking-while-holding-her-laptop-4008741-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/500x750_woman-cooking-while-holding-her-laptop-4008741-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/800x1200_woman-cooking-while-holding-her-laptop-4008741-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/our-family/500x750_woman-cooking-while-holding-her-laptop-4008741-jpg.jpg",
            "width": 1280
         },
         {
            "faces": [],
            "height": 853,
            "name": "woman-sitting-on-man-s-lap-4008708.jpg",
            "slug": "woman-sitting-on-man-s-lap-4008708-jpg",
            "src": "/fussel-demo/static/_gallery/albums/our-family/1280x853_woman-sitting-on-man-s-lap-4008708-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1024x682_woman-sitting-on-man-s-lap-4008708-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1280x853_woman-sitting-on-man-s-lap-4008708-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/500x333_woman-sitting-on-man-s-lap-4008708-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/800x533_woman-sitting-on-man-s-lap-4008708-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/our-family/500x333_woman-sitting-on-man-s-lap-4008708-jpg.jpg",
            "width": 1280
         },
         {
            "faces": [],
            "height": 1919,
            "name": "woman-sitting-on-the-desk-holding-a-book-4008713.jpg",
            "slug": "woman-sitting-on-the-desk-holding-a-book-4008713-jpg",
            "src": "/fussel-demo/static/_gallery/albums/our-family/1280x1919_woman-sitting-on-the-desk-holding-a-book-4008713-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1024x1535_woman-sitting-on-the-desk-holding-a-book-4008713-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/1280x1919_woman-sitting-on-the-desk-holding-a-book-4008713-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/500x749_woman-sitting-on-the-desk-holding-a-book-4008713-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/our-family/800x1199_woman-sitting-on-the-desk-holding-a-book-4008713-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/our-family/500x749_woman-sitting-on-the-desk-holding-a-book-4008713-jpg.jpg",
            "width": 1280
         }
      ],
      "slug": "our-family",
      "src": "/fussel-demo/static/_gallery/albums/our-family/500x333_checking-their-planner-4008732-jpg.jpg"
   },
   "scenery": {
      "name": "Scenery",
      "photos": [
         {
            "faces": [],
            "height": 720,
            "name": ".green-and-brown-sailing-boat-1796727.jpg",
            "slug": "green-and-brown-sailing-boat-1796727-jpg",
            "src": "/fussel-demo/static/_gallery/albums/scenery/1280x720_green-and-brown-sailing-boat-1796727-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/1024x576_green-and-brown-sailing-boat-1796727-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/1280x720_green-and-brown-sailing-boat-1796727-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/500x281_green-and-brown-sailing-boat-1796727-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/800x450_green-and-brown-sailing-boat-1796727-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/scenery/500x281_green-and-brown-sailing-boat-1796727-jpg.jpg",
            "width": 1280
         },
         {
            "faces": [],
            "height": 854,
            "name": "accomplishment-action-adult-adventure-372098.jpg",
            "slug": "accomplishment-action-adult-adventure-372098-jpg",
            "src": "/fussel-demo/static/_gallery/albums/scenery/1280x854_accomplishment-action-adult-adventure-372098-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/1024x683_accomplishment-action-adult-adventure-372098-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/1280x854_accomplishment-action-adult-adventure-372098-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/500x333_accomplishment-action-adult-adventure-372098-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/800x533_accomplishment-action-adult-adventure-372098-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/scenery/500x333_accomplishment-action-adult-adventure-372098-jpg.jpg",
            "width": 1280
         },
         {
            "faces": [],
            "height": 862,
            "name": "alberta-amazing-attraction-banff-417074.jpg",
            "slug": "alberta-amazing-attraction-banff-417074-jpg",
            "src": "/fussel-demo/static/_gallery/albums/scenery/1280x862_alberta-amazing-attraction-banff-417074-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/1024x689_alberta-amazing-attraction-banff-417074-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/1280x862_alberta-amazing-attraction-banff-417074-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/500x336_alberta-amazing-attraction-banff-417074-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/800x538_alberta-amazing-attraction-banff-417074-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/scenery/500x336_alberta-amazing-attraction-banff-417074-jpg.jpg",
            "width": 1280
         },
         {
            "faces": [],
            "height": 796,
            "name": "architecture-art-bridge-cliff-459203.jpg",
            "slug": "architecture-art-bridge-cliff-459203-jpg",
            "src": "/fussel-demo/static/_gallery/albums/scenery/1280x796_architecture-art-bridge-cliff-459203-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/1024x636_architecture-art-bridge-cliff-459203-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/1280x796_architecture-art-bridge-cliff-459203-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/500x310_architecture-art-bridge-cliff-459203-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/800x497_architecture-art-bridge-cliff-459203-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/scenery/500x310_architecture-art-bridge-cliff-459203-jpg.jpg",
            "width": 1280
         },
         {
            "faces": [],
            "height": 853,
            "name": "architecture-building-countryside-daylight-126271.jpg",
            "slug": "architecture-building-countryside-daylight-126271-jpg",
            "src": "/fussel-demo/static/_gallery/albums/scenery/1280x853_architecture-building-countryside-daylight-126271-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/1024x682_architecture-building-countryside-daylight-126271-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/1280x853_architecture-building-countryside-daylight-126271-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/500x333_architecture-building-countryside-daylight-126271-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/800x533_architecture-building-countryside-daylight-126271-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/scenery/500x333_architecture-building-countryside-daylight-126271-jpg.jpg",
            "width": 1280
         },
         {
            "faces": [],
            "height": 853,
            "name": "asdf.jpg",
            "slug": "asdf-jpg",
            "src": "/fussel-demo/static/_gallery/albums/scenery/1280x853_asdf-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/1024x682_asdf-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/1280x853_asdf-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/500x333_asdf-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/800x533_asdf-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/scenery/500x333_asdf-jpg.jpg",
            "width": 1280
         },
         {
            "faces": [],
            "height": 720,
            "name": "bloom-blooming-country-countryside-145685.jpg",
            "slug": "bloom-blooming-country-countryside-145685-jpg",
            "src": "/fussel-demo/static/_gallery/albums/scenery/1280x720_bloom-blooming-country-countryside-145685-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/1024x576_bloom-blooming-country-countryside-145685-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/1280x720_bloom-blooming-country-countryside-145685-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/500x281_bloom-blooming-country-countryside-145685-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/800x450_bloom-blooming-country-countryside-145685-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/scenery/500x281_bloom-blooming-country-countryside-145685-jpg.jpg",
            "width": 1280
         },
         {
            "faces": [],
            "height": 1923,
            "name": "brown-wooden-house-surrounded-by-green-trees-1172064.jpg",
            "slug": "brown-wooden-house-surrounded-by-green-trees-1172064-jpg",
            "src": "/fussel-demo/static/_gallery/albums/scenery/1280x1923_brown-wooden-house-surrounded-by-green-trees-1172064-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/1024x1538_brown-wooden-house-surrounded-by-green-trees-1172064-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/1280x1923_brown-wooden-house-surrounded-by-green-trees-1172064-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/500x751_brown-wooden-house-surrounded-by-green-trees-1172064-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/800x1201_brown-wooden-house-surrounded-by-green-trees-1172064-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/scenery/500x751_brown-wooden-house-surrounded-by-green-trees-1172064-jpg.jpg",
            "width": 1280
         },
         {
            "faces": [],
            "height": 720,
            "name": "green-and-brown-sailing-boat-1796727.jpg",
            "slug": "green-and-brown-sailing-boat-1796727-jpg",
            "src": "/fussel-demo/static/_gallery/albums/scenery/1280x720_green-and-brown-sailing-boat-1796727-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/1024x576_green-and-brown-sailing-boat-1796727-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/1280x720_green-and-brown-sailing-boat-1796727-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/500x281_green-and-brown-sailing-boat-1796727-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/800x450_green-and-brown-sailing-boat-1796727-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/scenery/500x281_green-and-brown-sailing-boat-1796727-jpg.jpg",
            "width": 1280
         },
         {
            "faces": [],
            "height": 851,
            "name": "house-covered-with-red-flowering-plant-1438248.jpg",
            "slug": "house-covered-with-red-flowering-plant-1438248-jpg",
            "src": "/fussel-demo/static/_gallery/albums/scenery/1280x851_house-covered-with-red-flowering-plant-1438248-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/1024x680_house-covered-with-red-flowering-plant-1438248-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/1280x851_house-covered-with-red-flowering-plant-1438248-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/500x332_house-covered-with-red-flowering-plant-1438248-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/800x531_house-covered-with-red-flowering-plant-1438248-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/scenery/500x332_house-covered-with-red-flowering-plant-1438248-jpg.jpg",
            "width": 1280
         },
         {
            "faces": [],
            "height": 719,
            "name": "pave-covered-on-red-leaf-between-trees-693521.jpg",
            "slug": "pave-covered-on-red-leaf-between-trees-693521-jpg",
            "src": "/fussel-demo/static/_gallery/albums/scenery/1280x719_pave-covered-on-red-leaf-between-trees-693521-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/1024x575_pave-covered-on-red-leaf-between-trees-693521-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/1280x719_pave-covered-on-red-leaf-between-trees-693521-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/500x280_pave-covered-on-red-leaf-between-trees-693521-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/800x449_pave-covered-on-red-leaf-between-trees-693521-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/scenery/500x280_pave-covered-on-red-leaf-between-trees-693521-jpg.jpg",
            "width": 1280
         },
         {
            "faces": [],
            "height": 808,
            "name": "person-on-a-bridge-near-a-lake-747964.jpg",
            "slug": "person-on-a-bridge-near-a-lake-747964-jpg",
            "src": "/fussel-demo/static/_gallery/albums/scenery/1280x808_person-on-a-bridge-near-a-lake-747964-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/1024x646_person-on-a-bridge-near-a-lake-747964-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/1280x808_person-on-a-bridge-near-a-lake-747964-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/500x315_person-on-a-bridge-near-a-lake-747964-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/800x505_person-on-a-bridge-near-a-lake-747964-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/scenery/500x315_person-on-a-bridge-near-a-lake-747964-jpg.jpg",
            "width": 1280
         },
         {
            "faces": [],
            "height": 853,
            "name": "photo-of-huts-surrounded-by-flowers-733200.jpg",
            "slug": "photo-of-huts-surrounded-by-flowers-733200-jpg",
            "src": "/fussel-demo/static/_gallery/albums/scenery/1280x853_photo-of-huts-surrounded-by-flowers-733200-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/1024x682_photo-of-huts-surrounded-by-flowers-733200-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/1280x853_photo-of-huts-surrounded-by-flowers-733200-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/500x333_photo-of-huts-surrounded-by-flowers-733200-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/800x533_photo-of-huts-surrounded-by-flowers-733200-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/scenery/500x333_photo-of-huts-surrounded-by-flowers-733200-jpg.jpg",
            "width": 1280
         },
         {
            "faces": [],
            "height": 1920,
            "name": "photo-of-pine-trees-beside-mountains-4067968.jpg",
            "slug": "photo-of-pine-trees-beside-mountains-4067968-jpg",
            "src": "/fussel-demo/static/_gallery/albums/scenery/1280x1920_photo-of-pine-trees-beside-mountains-4067968-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/1024x1536_photo-of-pine-trees-beside-mountains-4067968-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/1280x1920_photo-of-pine-trees-beside-mountains-4067968-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/500x750_photo-of-pine-trees-beside-mountains-4067968-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/800x1200_photo-of-pine-trees-beside-mountains-4067968-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/scenery/500x750_photo-of-pine-trees-beside-mountains-4067968-jpg.jpg",
            "width": 1280
         },
         {
            "faces": [],
            "height": 1600,
            "name": "photo-of-railway-on-mountain-near-houses-1658967.jpg",
            "slug": "photo-of-railway-on-mountain-near-houses-1658967-jpg",
            "src": "/fussel-demo/static/_gallery/albums/scenery/1280x1600_photo-of-railway-on-mountain-near-houses-1658967-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/1024x1280_photo-of-railway-on-mountain-near-houses-1658967-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/1280x1600_photo-of-railway-on-mountain-near-houses-1658967-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/500x625_photo-of-railway-on-mountain-near-houses-1658967-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/800x1000_photo-of-railway-on-mountain-near-houses-1658967-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/scenery/500x625_photo-of-railway-on-mountain-near-houses-1658967-jpg.jpg",
            "width": 1280
         },
         {
            "faces": [],
            "height": 853,
            "name": "photo-of-snow-covered-mountain-during-dawn-4067902.jpg",
            "slug": "photo-of-snow-covered-mountain-during-dawn-4067902-jpg",
            "src": "/fussel-demo/static/_gallery/albums/scenery/1280x853_photo-of-snow-covered-mountain-during-dawn-4067902-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/1024x682_photo-of-snow-covered-mountain-during-dawn-4067902-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/1280x853_photo-of-snow-covered-mountain-during-dawn-4067902-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/500x333_photo-of-snow-covered-mountain-during-dawn-4067902-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/800x533_photo-of-snow-covered-mountain-during-dawn-4067902-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/scenery/500x333_photo-of-snow-covered-mountain-during-dawn-4067902-jpg.jpg",
            "width": 1280
         },
         {
            "faces": [],
            "height": 719,
            "name": "scenic-view-of-sea-against-sky-at-sunset-258109.jpg",
            "slug": "scenic-view-of-sea-against-sky-at-sunset-258109-jpg",
            "src": "/fussel-demo/static/_gallery/albums/scenery/1280x719_scenic-view-of-sea-against-sky-at-sunset-258109-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/1024x575_scenic-view-of-sea-against-sky-at-sunset-258109-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/1280x719_scenic-view-of-sea-against-sky-at-sunset-258109-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/500x280_scenic-view-of-sea-against-sky-at-sunset-258109-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/800x449_scenic-view-of-sea-against-sky-at-sunset-258109-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/scenery/500x280_scenic-view-of-sea-against-sky-at-sunset-258109-jpg.jpg",
            "width": 1280
         },
         {
            "faces": [],
            "height": 1927,
            "name": "scenic-view-of-waterfalls-1598073.jpg",
            "slug": "scenic-view-of-waterfalls-1598073-jpg",
            "src": "/fussel-demo/static/_gallery/albums/scenery/1280x1927_scenic-view-of-waterfalls-1598073-jpg.jpg",
            "srcSet": {
               "(1024, 1024)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/1024x1541_scenic-view-of-waterfalls-1598073-jpg.jpg"
               ],
               "(1600, 1600)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/1280x1927_scenic-view-of-waterfalls-1598073-jpg.jpg"
               ],
               "(500, 500)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/500x752_scenic-view-of-waterfalls-1598073-jpg.jpg"
               ],
               "(800, 800)w": [
                  "/fussel-demo/static/_gallery/albums/scenery/800x1204_scenic-view-of-waterfalls-1598073-jpg.jpg"
               ]
            },
            "thumb": "/fussel-demo/static/_gallery/albums/scenery/500x752_scenic-view-of-waterfalls-1598073-jpg.jpg",
            "width": 1280
         }
      ],
      "slug": "scenery",
      "src": "/fussel-demo/static/_gallery/albums/scenery/500x281_green-and-brown-sailing-boat-1796727-jpg.jpg"
   }
};